import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import LoadingScreen from "../components/LoadingScreen/LoadingScreen";

export default function AdminRoute() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Com auth otimista o /me ainda pode estar carregando: sem isso, o admin
  // que dá F5 em /dashboard/admin era chutado pro dashboard.
  if (!user) {
    return <LoadingScreen />;
  }

  if (user.is_admin !== true) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
